export default "__VITE_ASSET__EXml6lej__"